import { CommonKeys } from "../../common/enums";
import { FORMULAR_GROUP_INPUTS_TYPE, FORMULAR_INPUT_TYPE, FORMULAR_INPUTS_TYPE } from "../../common/formular-group-types";

const FormularGroupInputsSchema = {
    $id: "FormularGroupInputsSchema",
    title: "FormularGroupInputs Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUP_INPUTS_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string" },
        [CommonKeys.ShowLabel]: { type: "boolean" },
        Inputs: { $ref: "FormularGroupInputsInputsSchema" }
    },
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label]
}

const FormularGroupInputsInputsSchema = {
    $id: "FormularGroupInputsInputsSchema",
    title: "FormularGroupInputsInputs Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_INPUTS_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: { $ref: "FormularGroupInputsInputSchema" }
        },
    },
    required: [CommonKeys.Type, CommonKeys.Values]
}

const FormularGroupInputsInputSchema = {
    $id: "FormularGroupInputsInputSchema",
    title: "FormularGroupInputsInput Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_INPUT_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true },
        [CommonKeys.Value]: {
            anyOf: [
                { type: ["string"], nullable: true },
                { type: ["boolean"], nullable: true },
                { type: ["number"], nullable: true }
            ]
        },
        Options: {
            type: "object",
            properties: {
                MinLen: { type: "number", nullable: true },
                MaxLen: { type: "number", nullable: true },
                KeyboardType: { type: "number", nullable: true }
            },
            nullable: true
        },
        Type: { type: "number", nullable: true }
    },
    required: [CommonKeys.ID, CommonKeys.Label, CommonKeys.Value]
}

export const FORMULAR_GROUP_INPUTS_SCHEMAS = [
    FormularGroupInputsSchema,
    FormularGroupInputsInputsSchema,
    FormularGroupInputsInputSchema
]